import * as XLSX from "xlsx";
import { queryClient } from "$utils/queryClient";
import { downloadFile, jsons2arrays, jsons2csv } from "./utils";
import { formatDateTime } from "$utils/utils";

export const EnumExportType = {
  CSV: "csv",
  XLSX: "xlsx",
} as const;

export type ExportType = (typeof EnumExportType)[keyof typeof EnumExportType];

export const exportFile = async ({
  header,
  queryFunction,
  queryFunctionName,
  type,
  fileName,
  filters,
  opts,
  companyName,
}: any) => {
  // TODO idealement il faudrait faire une boucle à la place du limit absurde (comme ça on prépare la pagination)
  let { data } = await queryClient.fetchQuery(
    [queryFunctionName, 1, 500000, filters],
    async () =>
      queryFunction?.({
        page: 1,
        rowsPerPage: 500000,
        ...filters,
      }),
    {
      staleTime: 1000 * 60,
      retry: 1,
    }
  );

  const prependCompany = () => {
    if (!companyName) {
      // eslint-disable-next-line no-alert
      alert("il y a une erreur de cache, rafraichir la page");
      return false;
    }
    if (header[0].label !== "entreprise*") {
      header.unshift({
        label: "entreprise*",
        key: ({ companyName: cn }) => cn,
      });
      data = data.map((d) => ({ ...d, companyName }));
    }
    return true;
  };

  switch (type) {
    case EnumExportType.CSV: {
      // eslint-disable-next-line no-param-reassign
      opts = { separator: ";", ...opts };
      if (!prependCompany()) return;
      data = data.map((d) => ({
        ...d,
        reference: d.reference?.replace(/"/g, '""') ?? d.reference,
        designation: d.designation?.replace(/"/g, '""') ?? d.designation,
      }));
      const check = jsons2csv(data, header, opts.separator, '"');
      return downloadFile(new Response(check), `${fileName}`, type, true);
    }
    case EnumExportType.XLSX: {
      if (!prependCompany()) return;
      const rows = jsons2arrays(data, header);
      const ws = XLSX.utils.aoa_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Export");
      XLSX.writeFile(wb, `${fileName}-${formatDateTime()}.xlsx`);
      return;
    }
    default:
      throw new Error("you need a valid type");
  }
};
